import { useTranslation } from 'react-i18next';
import { StoryCardStatus } from '../../../services';

export const useCardStatusFilter = () => {
  const { t } = useTranslation();

  return {
    group: {
      id: 'status',
      title: t('common.status'),
      multiCheck: true,
      allowReset: true,
      items: [
        {
          id: StoryCardStatus.PUBLISHED,
          label: t('common.published'),
          value: StoryCardStatus.PUBLISHED,
        },
        {
          id: StoryCardStatus.UNPUBLISHED,
          label: t('common.unpublished'),
          value: StoryCardStatus.UNPUBLISHED,
        },
        {
          id: StoryCardStatus.SCHEDULED,
          label: t('common.scheduled'),
          value: StoryCardStatus.SCHEDULED,
        },
      ],
    },
  };
};
